import React from 'react';
import './style.css';
import { Footer, Header, HeaderPages } from "../../components";

export const AboutPage: React.FC = () => {

    const ContactPanel = () => {
        return (
            <div className="contact-panel light-background section">
                <div className="panel-contents">
                    <div className="panel-title">
                        About Us
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Header currentPage={HeaderPages.About} />
            <ContactPanel />
            <Footer />
        </>
    );
};
